import { render } from "./EditPerson.vue?vue&type=template&id=c9ca6e02&ts=true"
import script from "./EditPerson.vue?vue&type=script&lang=ts"
export * from "./EditPerson.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__